export default __webpack_public_path__ + "static/media/sample-0.a84c1efc.jpeg";